import { ALLOCATION_GROUPS } from '../constants';
import { AbTests } from '../types';
import { getAllocatedGroup } from '.';

/**
 * Checks if the user is allocated to any of the experimental groups (group 2+)
 * @param {number|string} experimentId - the experiment id you want to check
 * @param {AbTests} abTests - from RequestContext or FiverrContext
 * @returns {boolean} - Returns TRUE if the user is allocated to any of the experimental groups. FALSE otherwise.
 */
export const isInExperiment = (experimentId: number | string, abTests: AbTests = {}): boolean => {
    const allocatedGroup = getAllocatedGroup(experimentId, abTests);

    return allocatedGroup >= ALLOCATION_GROUPS.B;
};
